"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AwardParticpateSubset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const Subset_1 = require("../Subset");
class AwardParticpateSubset extends Subset_1.SubsetClass {
    constructor() {
        super(...arguments);
        this.getParticipantsLive = (award, completed, searchIds = [], startAfter) => {
            const params = {
                dataset: this.dataset,
                setId: award,
                subset: this.subset,
                fieldName: searchIds.map(() => 'uid').concat('completed'),
                fieldValue: searchIds.concat(completed),
                operator: searchIds.map(() => interfaces_1.Opr.IN).concat(interfaces_1.Opr.EQUAL),
                startAfter,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
        this.getTopByMemberLive = (member, completed = true, startAfter) => {
            const params = {
                dataset: this.dataset,
                subset: this.subset,
                fieldName: ['uid', 'parentCol', 'completed'],
                fieldValue: [member, this.dataset, completed],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
    }
}
exports.AwardParticpateSubset = AwardParticpateSubset;
